import { render, staticRenderFns } from "./donation-row.vue?vue&type=template&id=4f2f1c89&scoped=true&"
import script from "./donation-row.vue?vue&type=script&lang=js&"
export * from "./donation-row.vue?vue&type=script&lang=js&"
import style0 from "./donation-row.vue?vue&type=style&index=0&id=4f2f1c89&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2f1c89",
  null
  
)

export default component.exports